import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import strings from "translate/language";
import { getsupportForumDetail } from "reduxStore/action/supportForumAction";
import { handleDetailResponse, seo } from "utils/utils";
import VideoModel from "component/common/videoModel";
import ImageRender from "component/common/ImageRender";
import Breadcrumb from "component/common/breadcrumb";

const ViewSupportForum = () => {
  const navigate = useNavigate();
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const [videoDetails, setVideoDetails] = useState(null);
  const [supportForumDetail, setSupportForumDetail] = useState({});
  const [baseUrl, setBaseUrl] = useState("");
  const params = useParams();
  const { support_forum_id = "" } = params || {};
  const dispatch = useDispatch();
  const supportForumDetailSelector =
    useSelector((state) => state.supportForum) || {};

  useEffect(() => {
    dispatch(getsupportForumDetail({ support_forum_id }));
  }, []);

  useEffect(() => {
    if (supportForumDetailSelector.response) {
      const { response } = supportForumDetailSelector;
      if (response?.status === 200) {
        setSupportForumDetail(handleDetailResponse(response?.data));
      } else {
        setSupportForumDetail({});
      }
    }
    setBaseUrl(supportForumDetailSelector.response.data[0].base_url);
  }, [supportForumDetailSelector]);

  useEffect(() => {
    seo({
      title: "Support Forum Details",
      metaDescription: "Support forum details",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.supportForumdDetails}
        url={"/supportforum"}
        parentListing={strings.supportForumList}
        titleactive={strings.viewsupportforumdetails}
        isBackBtn={true}
      />
      <VideoModel data={videoDetails} />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-3">
                <h5>{strings.supportforumdetails}</h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className=" col-md-3 align-items-center">
                    <label htlmFor="exampleInputMobileNo">
                      {strings.title} :
                    </label>
                  </div>
                  <div className=" col-md-3 align-items-center">
                    <label htlmFor="exampleInputMobileNo" className="boldText">
                      {supportForumDetail?.title}{" "}
                    </label>
                  </div>
                </div>
                <hr />

                <div className="row">
                  <div className=" col-md-3 align-items-center">
                    <label htlmFor="exampleInputMobileNo">
                      {strings.location} :
                    </label>
                  </div>

                  <div className=" col-md-7 align-items-center">
                    <label htlmFor="exampleInputMobileNo" className="boldText">
                      {supportForumDetail?.location}
                    </label>
                  </div>
                </div>
                <hr />

                <div className="row">
                  <div className=" col-md-3 align-items-center">
                    <label htlmFor="exampleInputMobileNo">
                      {strings.description} :
                    </label>
                  </div>
                  <div className=" col-md-7 align-items-center">
                    <label htlmFor="exampleInputMobileNo" className="boldText">
                      {supportForumDetail?.description}
                    </label>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className=" col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.content} :
                    </label>
                  </div>
                  {supportForumDetail?.support_forum_content &&
                    supportForumDetail?.support_forum_content.length > 0 ? (
                    <>
                      {supportForumDetail?.support_forum_content.filter(
                        (item) => item.content_type === "image"
                      ).length > 0 && (
                          <div className=" col-md-7">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {strings.images}
                            </label>
                            <div className="row">
                              {supportForumDetail?.support_forum_content
                                ? supportForumDetail?.support_forum_content?.map(
                                  (item, index) =>
                                    item.content_type === "image" &&
                                    index < 3 && (
                                      <ImageRender
                                        key={index}
                                        baseUrl={baseUrl}
                                        imageUrl={item.content}
                                        thumbnailUrl={item.content}
                                      />
                                    )
                                )
                                : strings.notavailable}
                              {supportForumDetail?.support_forum_content.filter(
                                ({ content_type }) => content_type === "image"
                              ).length > 3 ? (
                                <div className="col-md-3">
                                  <i
                                    className="fa fa-arrow-circle-o-right right-icon pt-5"
                                    aria-hidden="true"
                                    onClick={() =>
                                      navigatpage(
                                        "/ViewSupportForumGallary/image/" +
                                        support_forum_id
                                      )
                                    }
                                  ></i>
                                </div>
                              ) : null}
                            </div>
                            <hr />
                          </div>
                        )}
                      <div className="col-md-3 align-items-center"></div>
                      {supportForumDetail?.support_forum_content &&
                        supportForumDetail?.support_forum_content.filter(
                          (item) => item.content_type === "video"
                        ).length > 0 && (
                          <div className="col-md-7 align-items-center">
                            <label
                              htmlFor="exampleInputMobileNo"
                              className="boldText"
                            >
                              {strings.videos}
                            </label>
                            <div className="row">
                              <div className="row">
                                {supportForumDetail?.support_forum_content
                                  .filter(
                                    (item) => item.content_type === "video"
                                  )
                                  .map(
                                    (item, i) =>
                                      i < 3 && (
                                        <div key={i} className="col-md-3">
                                          <img
                                            src={baseUrl + item.video_thumbnail}
                                            className="img-thumbnail"
                                            style={{ position: "relative" }}
                                          />
                                          <i
                                            className="fa fa-play theme-fa-icon"
                                            style={{
                                              position: "absolute",
                                              right: " 64px",
                                              top: "24px",
                                              cursor: "pointer",
                                              color: "#fff",
                                            }}
                                            data-toggle="modal"
                                            data-original-title="test"
                                            data-target="#exampleModal"
                                            onClick={() => {
                                              item.base_url = baseUrl;
                                              item.document = item.content;
                                              setVideoDetails(item);
                                            }}
                                          ></i>
                                        </div>
                                      )
                                  ) || strings.notavailable}
                                {supportForumDetail?.support_forum_content.filter(
                                  ({ content_type }) => content_type === "video"
                                ).length > 3 ? (
                                  <div className="col-md-3">
                                    <i
                                      className="fa fa-arrow-circle-o-right right-icon pt-4"
                                      aria-hidden="true"
                                      onClick={() =>
                                        navigatpage(
                                          "/ViewSupportForumGallary/video/" +
                                          support_forum_id
                                        )
                                      }
                                    ></i>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        )}
                    </>
                  ) : (
                    <div className=" col-md-3 align-items-center">
                      {strings.notavailable}
                    </div>
                  )}
                </div>
                <hr />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ViewSupportForum;
